
const http = require('http')

/*
 * API 서버에 GET 요청을 보낸다
 */
const get = (host, port, path, params={}) => new Promise((resolve, reject) => {
    const queryString = Object.entries(params).map(([key, value]) => key + '=' + encodeURIComponent(value)).join('&')
    if(queryString != '') path += '?' + queryString
    const req = http.request({host, port, path, method: 'GET'}, (res) => {
        let body = ''
        res.on('data', (chunk) => body += chunk)
        res.on('end', () => res.statusCode == 200 ? resolve(JSON.parse(body)) : reject(new Error(res.statusCode)))
        res.on('error', (err) => reject(err))
    })
    req.on('error', (err) => reject(err))
    req.end()
})

/*
 * API 서버에 POST 요청을 보낸다
 * data는 JSON으로 변환될 오브젝트 형식, Promise의 결과값은 JSON으로부터 파싱된 오브젝트.
 */
const post = (host, port, path, data) => new Promise((resolve, reject) => {
    const json = JSON.stringify(data)
    const req = http.request({host, port, path, method: 'POST', headers: {'Content-Type': 'application/json', 'Content-Length': json.length}}, (res) => {
        let body = ''
        res.on('data', (chunk) => body += chunk)
        res.on('end', () => res.statusCode == 200 ? resolve(JSON.parse(body)) : reject(new Error(res.body)))
        res.on('error', (err) => reject(err))
    })
    req.write(json)
    req.on('error', (err) => reject(err))
    req.end()
})

/*
 * API 서버에 POST 요청을 보낸다
 */
const postFile = (host, port, path, form) => new Promise((resolve, reject) => {
    const formData = new FormData(form)
    const xhr = new XMLHttpRequest()
    xhr.open('POST', `http://${host}:${port}${path}`, true)
    xhr.onload = (e) => {
        if(xhr.status === 200) resolve()
        else reject()
    }
    xhr.send(formData)
})

/*
 * API 서버에 DELETE 요청을 보낸다
 */
const del = (host, port, path, params={}) => new Promise((resolve, reject) => {
    const queryString = Object.entries(params).map(([key, value]) => key + '=' + encodeURIComponent(value)).join('&')
    if(queryString != '') path += '?' + queryString
    const req = http.request({host, port, path, method: 'DELETE'}, (res) => {
        let body = ''
        res.on('data', (chunk) => body += chunk)
        res.on('end', () => res.statusCode == 200 ? resolve(JSON.parse(body)) : reject(new Error(res.statusCode)))
        res.on('error', (err) => reject(err))
    })
    req.on('error', (err) => reject(err))
    req.end()
})

module.exports = {get, post, postFile, del}
